import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import getAutomationRunEvents from '@/redux/requests/getAutomationRunEvents.js';
import { automationRunEventsLoaded, automationRunSteps } from '@/redux/selectors/pieveSelectors/automationCatalogSelectors.js';
import RunStepList from './RunStepList.jsx';

const REFRESH_MS = 4000;

/** What a schedule or trigger run did, read from its conversation. Refreshes while the run is still going. */
const ConversationRunDetails = ({ threadId, isLive }) => {
  const { steps, result } = useSelector((state) => automationRunSteps(state, threadId));
  const loaded = useSelector((state) => automationRunEventsLoaded(state, threadId));

  useEffect(() => {
    getAutomationRunEvents({ threadId });

    if (!isLive) {
      return undefined;
    }

    const timer = setInterval(() => getAutomationRunEvents({ threadId }), REFRESH_MS);
    return () => clearInterval(timer);
  }, [threadId, isLive]);

  return <RunStepList steps={steps} result={result} loading={!loaded} isLive={isLive} />;
};

export default ConversationRunDetails;
